// src/components/Seguridad/Components/Catalogos/Usuarios/UsuariosTabs.jsx
import { useState } from 'react';
import UsuarioRolTab from '../../Tabs/UsuarioRolTab';

const tabsList = [
    { key: 'roles', label: 'Roles Asignados' },
    // Agregar más tabs aquí si es necesario
];

export default function UsuariosTabs({ usuarioId, onClose }) {
    const [active, setActive] = useState('roles');
    const hasValidContext = Number(usuarioId || 0) > 0;

    if (!hasValidContext) {
        return (
            <div className="person-tabs-disabled">
                <span>
                    Selecciona o crea un usuario y pulsa <b>Editar</b> para gestionar sus roles.
                </span>
            </div>
        );
    }

    return (
        <div className="person-tabs-wrap">
            <div className="person-tabs-bar">
                {tabsList.map((t) => (
                    <button
                        key={t.key}
                        className={`person-tab ${active === t.key ? 'is-active' : ''}`}
                        onClick={() => setActive(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="person-tab-panel">
                {active === 'roles' && <UsuarioRolTab fkValue={usuarioId} onClose={onClose} />}
            </div>
        </div>
    );
}
